// Routing, actions and per-seat screen state. No framework: a hash router and event delegation.

import type { Trusted } from './html.ts';
import { world as w } from './world.ts';

export type Tab = 'nearby' | 'sell' | 'chats' | 'me' | 'cases' | null;

export interface Screen {
  title: string;
  body: Trusted;
  tab: Tab;
}

type Handler = (el: HTMLElement) => void | Promise<void>;
type FormHandler = (fd: FormData, form: HTMLFormElement) => void | Promise<void>;
export const acts = new Map<string, Handler>();
export const forms = new Map<string, FormHandler>();
export const on = (name: string, h: Handler): void => void acts.set(name, h);
export const onForm = (name: string, h: FormHandler): void => void forms.set(name, h);

// Screen state that is not on the record (a half-finished join, a flash line). Kept per seat.
export interface Local {
  flash?: string;
  // A flash or a refusal belongs to the first screen it is shown on, and lasts until the person leaves it.
  shownOn?: string;
  otp?: { code: string; last: string; fingerprint: string };
  verified?: boolean;
  vouchFound?: string;
  error?: string;
  why?: { predicate: string; title: string; decision: import('@model/index.ts').Decision };
}
const locals = new Map<string, Local>();
export const local = (seat: string = w.seat): Local => {
  let l = locals.get(seat);
  if (!l) locals.set(seat, (l = {}));
  return l;
};
export const resetLocals = (): void => locals.clear();

export function flash(text: string): void {
  local().flash = text;
  local().shownOn = undefined;
}

export function refuse(predicate: string, title: string, decision: import('@model/index.ts').Decision): void {
  local().why = { predicate, title, decision };
  local().shownOn = undefined;
}

export function path(): string[] {
  const h = location.hash.replace(/^#\/?/, '');
  return h ? h.split('/').map(decodeURIComponent) : [];
}

export function go(hash: string): void {
  if (location.hash === hash) window.dispatchEvent(new HashChangeEvent('hashchange'));
  else location.hash = hash;
}
